import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { SettingsSection } from "components/Settings/SettingsSection";
import { Link } from "react-router-dom";
import { useLoadCounter } from "hooks/useLoadCounter";

export const ManufacturersSection = () => {
  const {
    loading: manufacturersLoading,
    error: manufacturersError,
    response: manufacturersResponse
  } = useFetchGetV2("manufacturers?ordering=id");
  const tableLoadCount = useLoadCounter(manufacturersLoading);

  if (manufacturersLoading) {
    return <></>;
  }

  if (manufacturersError) {
    return <></>;
  }

  if (manufacturersResponse) {
    return (
      <>
        <SettingsSection title="Manufacturers">
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell data-col={1}>ID</TableCell>
                  <TableCell data-col={2}>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody
                data-qa_loading={manufacturersLoading}
                data-qa_load_count={tableLoadCount}
              >
                {manufacturersResponse &&
                  manufacturersResponse?.results.map(manufacturer => (
                    <TableRow key={manufacturer.id}>
                      <TableCell data-col={1}>{manufacturer.id}</TableCell>
                      <TableCell data-col={2}>
                        <Link
                          to={`/pages/settings/manufacturer/${manufacturer.id}`}
                        >
                          {`${manufacturer.name}`}
                        </Link>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </SettingsSection>
      </>
    );
  }
};
